import { addDoubleQuotes } from '../utils/smartutils';

export function relationObjectListByParamsQuery(
  showResponsible,
  showResponsibleType,
  showAll,
  showResponsibleKindWithStudent,
  type,
  showStudents = true,
  showSchoolClasses = true
) {
  const query = `
    {
        relationObjectListByParams(showResponsible: ${showResponsible},
        showResponsibleType: ${showResponsibleType},
        showAll: ${showAll},
        showResponsibleKindWithStudent: ${showResponsibleKindWithStudent}
        type: ${addDoubleQuotes(type)}
        showStudents: ${showStudents}
        showSchoolClasses: ${showSchoolClasses}
        ){id, description, quantity, type, identifier}
    }`;
  return query;
}

export function relationObjectListBySchoolClassQuery(
  showResponsible,
  showResponsibleType,
  showAll = true,
  showResponsibleKindWithStudent = false,
  type,
  showStudents = false,
  showSchoolClasses = true
) {
  const query = `
    {
        relationObjectListByParams(showResponsible: ${showResponsible},
        showResponsibleType: ${showResponsibleType},
        showAll: ${showAll},
        showResponsibleKindWithStudent: ${showResponsibleKindWithStudent}
        type: ${addDoubleQuotes(type)}
        showStudents: ${showStudents}
        showSchoolClasses: ${showSchoolClasses}
        ){id, description, quantity, type, identifier}
    }`;
  return query;
}

export function relationObjectListByParamsAndCourseStepQuery(
  showResponsible,
  showResponsibleType,
  showAll,
  showResponsibleKindWithStudent,
  courseStepId,
  type
) {
  const query = `
    {
        relationObjectListByParamsAndCourseStep(showResponsible: ${showResponsible},
        showResponsibleType: ${showResponsibleType},
        showAll: ${showAll},
        showResponsibleKindWithStudent: ${showResponsibleKindWithStudent}
        courseStepId: ${courseStepId}
        type: ${addDoubleQuotes(type)}
        ){id, description, quantity, type, identifier}
    }`;
  return query;
}

export function relationObjectListByCommunicationId(communicationId) {
  const query = `
    {
      relationObjectListByCommunicationId(communicationId: ${communicationId}){id, description, quantity, type, identifier}
    }`;
  return query;
}

export function relationObjectAuditListByCommunicationId(communicationId) {
  return `{
  relationObjectListByCommunicationId(communicationId: ${communicationId}) {
    id
    description
    photoUrl
  }
}
`;
}
